import events from '.';
import getWindowSize from '../utils/window-size';

window.addEventListener('resize', () => events.emit('resize', getWindowSize()));
